// Three.js built-ins (RawShaderMaterial requires explicit declarations)
uniform mat4  projectionMatrix;
uniform mat4  viewMatrix;

in vec3  position;
in vec2  uv;

// Per-instance attributes
in vec3  aOffset;       // world position
in vec2  aScaleAlpha;   // x = size, y = alpha
in vec2  aTileEmissive; // x = tile index, y = emissive strength
in vec3  aColor;        // RGB tint
in float aRotation;     // billboard rotation (radians)

uniform float uAtlasSize;     // tiles per row (e.g. 4)
uniform float uLogDepthBufFC; // 2.0 / log2(far + 1.0)
uniform float uNearFadeStart; // view-space distance where alpha starts fading to 0
uniform float uNearFadeEnd;   // view-space distance where alpha reaches full

out vec2  vUv;
out float vAlpha;
out float vEmissive;
out vec3  vColor;
out float vFragDepth;

void main() {
  // Billboard: extract camera-right and camera-up from the view matrix
  vec3 camRight = vec3(viewMatrix[0][0], viewMatrix[1][0], viewMatrix[2][0]);
  vec3 camUp    = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);

  float size = aScaleAlpha.x;

  // Rotate the quad corner around the billboard normal
  float c = cos(aRotation);
  float s = sin(aRotation);
  vec2 rotated = vec2(
    position.x * c - position.y * s,
    position.x * s + position.y * c
  );

  // position is the unit quad (-0.5..0.5) scaled and oriented to face camera
  vec3 worldPos = aOffset
    + camRight * (rotated.x * size)
    + camUp    * (rotated.y * size);

  gl_Position = projectionMatrix * viewMatrix * vec4(worldPos, 1.0);

  // Logarithmic depth buffer support
  gl_Position.z = log2(max(1e-6, gl_Position.w + 1.0)) * uLogDepthBufFC - 1.0;
  gl_Position.z *= gl_Position.w;
  vFragDepth = 1.0 + gl_Position.w;

  // Atlas UV: tile index → row/col
  float tile = aTileEmissive.x;
  float col  = mod(tile, uAtlasSize);
  float row  = floor(tile / uAtlasSize);
  float invS = 1.0 / uAtlasSize;
  // uv from geometry is 0..1, remap into tile sub-rect
  vUv = (vec2(col, row) + uv) * invS;

  // Near-camera fade: dissolve particles that get close to the view,
  // so trails left behind the aircraft don't clip through the cockpit.
  float viewDist = gl_Position.w;
  float nearFade = smoothstep(uNearFadeStart, uNearFadeEnd, viewDist);

  vAlpha    = aScaleAlpha.y * nearFade;
  vEmissive = aTileEmissive.y;
  vColor    = aColor;
}
